import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import MetaTags from '../components/common/MetaTags';

import LocaleContext from '../contexts/LocaleContext';
import { getCareersPage } from '../js/api/careers-page';
import CareersData from '../models/CareersPageData';
import HeroSection from '../components/Careers/HeroSection';
import CultureEnvironment from '../components/Careers/CultureEnvironment';
import KeyTeamsSlider from '../components/Careers/KeyTeams/KeyTeamsSlider';
import BenefitsPolices from '../components/Careers/BenefitsPolices';
import EducationalProgram from '../components/Careers/EducationalProgram';

export default function CareersPage() {
  const { locale } = useContext(LocaleContext);
  const { t } = useTranslation(['CareersPage']);
  const [careersPageData, setCareersPageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    getCareersPage()
      .then((res) => {
        setCareersPageData(new CareersData(res.data));
      })
      .catch((e) => {
        toast.error('An error occurred, try again later');
        throw e;
      })
      .finally(() => setIsLoading(false));
  }, [locale]);

  return (
    <main className="careers">
      {!isLoading && careersPageData ? (
        <>
          <MetaTags title={t('pageTitle')} seo={careersPageData?.metaTags} />
          <HeroSection data={careersPageData?.heroData} />

          <CultureEnvironment
            title1={careersPageData?.eduaction_culture?.text1_line1}
            title2={careersPageData?.eduaction_culture?.text1_line2}
            description={careersPageData?.eduaction_culture?.description_1}
            image={careersPageData?.eduaction_culture?.image1}
          />

          <CultureEnvironment
            title1={careersPageData?.eduaction_culture?.text2_line1}
            title2={careersPageData?.eduaction_culture?.text2_line2}
            description={careersPageData?.eduaction_culture?.description_2}
            image={careersPageData?.eduaction_culture?.image2}
            isReversed
          />

          <EducationalProgram data={careersPageData?.media_with_title} />

          <BenefitsPolices data={careersPageData?.benefits} />

          <KeyTeamsSlider
            buttonLink={careersPageData?.explore?.link}
            slides={careersPageData?.keyTeam}
          />
        </>
      ) : null}
    </main>
  );
}
